<script setup lang="ts">
import { SCHEMA_URL } from '#shared/constant/constant'
import { postWindowBridge } from '@/utils/windowBridge'

const router = useRouter()
// commonFunction プラグインが受信・検証して格納する URL スキーム（キーはプラグインと揃える）。
// URL スキーム用の composable が無いため、useState を直接参照する
const urlScheme = useState<string>('url_schema', () => '')
useHead({
  title: '',
})

/**
 * 前のページへ戻る。アプリから直接開いた最初の画面（戻る履歴が無い）では、アプリのホームへ戻す。
 * URL スキームを受信していない場合（アプリの外のブラウザなど）は、履歴を戻る。
 */
function sendGooHome(): void {
  const isFirstScreen = window.history.length <= 1
  const hasUrlScheme = urlScheme.value !== ''
  if (isFirstScreen && hasUrlScheme) {
    window.open(`${urlScheme.value}${SCHEMA_URL.home}`, '_blank')
    return
  }
  router.go(-1)
}

onMounted(() => {
  // ホームへ戻すための URL スキームをアプリに要求する（SSR で失敗した場合はページ側の要求が走らないため）
  postWindowBridge('getUserDataFromApp', true)
  postWindowBridge('toggleCloseButton', false)
  postWindowBridge('toggleTopButton', false)
  postWindowBridge('toggleShareButton', false)
  postWindowBridge('toggleBottomBar', true)
  postWindowBridge('setAppBarTitle', '')
  postWindowBridge('toggleFavoriteButton', false)
})
</script>
<template>
  <div class="error-contents">
    <div class="error-message">
      正常に処理できませんでした。<br />再度お試しください。
    </div>
    <div class="btn-area">
      <button class="rounded button" @click="sendGooHome()">
        <a>前のページへ戻る</a>
      </button>
    </div>
  </div>
</template>

<style scoped>
.button {
  color: #ffffff;
  height: 44px;
  font-weight: bold;
  background-color: #df2020;
  border: none;
  width: 100%;
  margin-top: 68px;
}

.btn-area {
  margin-left: 16px;
  margin-right: 16px;
}

.error-contents {
  text-align: center;
  margin-top: 68px;
}

.error-message {
  font-size: 16px;
  font-family: 'Hiragino Kaku Gothic Pro';
  margin-left: 31px;
  margin-right: 31px;
}
</style>
